import { render, staticRenderFns } from "./DialogNovoGrupoContatos.vue?vue&type=template&id=2d428b92"
import script from "./DialogNovoGrupoContatos.vue?vue&type=script&lang=js"
export * from "./DialogNovoGrupoContatos.vue?vue&type=script&lang=js"
import style0 from "./DialogNovoGrupoContatos.vue?vue&type=style&index=0&id=2d428b92&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports